import { StateSchema } from 'app/config/storeConfig/types';

export const getGridCellSize = (state: StateSchema): number => state.warehouseMapConstructor.gridCellSize;
